"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NewsletterButton = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.NewsletterButton = styled_components_1.default.button `
	&& {
		color: ${(p) => p.theme.palette.accent.backgroundText};
		background: ${(p) => p.theme.palette.accent.background};
		transition: background 0.3s ${(p) => p.theme.easing};
		&:hover {
			background: ${(p) => p.theme.palette.accent.backgroundHover};
		}
	}

	font-family: ${(p) => p.theme.fonts.default};
	font-size: 13px;
	line-height: 16px;
	letter-spacing: 2px;
	font-weight: 600;
	text-decoration: none;
	text-transform: uppercase;
	margin-bottom: 32px;
	padding: 12px 24px;
	cursor: pointer;

	${(p) => p.theme.breakpoints.down("sm")} {
		margin-bottom: 0;
	}
`;
//# sourceMappingURL=NewsletterButton.atom.js.map